import { useSelector as useRedux, shallowEqual, useDispatch } from 'react-redux'

const useSelector = selector => useRedux(selector, shallowEqual);
export { useDispatch, useSelector };